import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=20890abc&"
import script from "./ThankYou.vue?vue&type=script&lang=js&"
export * from "./ThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports